import { actionTypes, IDistrictState } from 'src/ducks/district.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getDistrictStatus = (
  state: IDistrictState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
